import {
  Button,
  Card,
  Col,
  message,
  Row,
  Table,
  Input,
  Modal,
  Select,
} from "antd";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllMeeting } from "redux/features/sidang";
import moment from "moment";
import { fetchAllReses } from "redux/features/reses";
import { fetchAllActivity } from "redux/features/activity";

const LocalizedModal = () => {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const hideModal = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        title="Modal"
        open={open}
        onOk={hideModal}
        onCancel={hideModal}
        okText="Ok"
        cancelText="Cancel"
      >
        <p>Bla bla ...</p>
        <p>Bla bla ...</p>
        <p>Bla bla ...</p>
      </Modal>
    </>
  );
};

export const KEGIATANKU = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const [isLoading, setLoading] = useState(true);
  const [isLoadingSidang, setLoadingSidang] = useState(true);
  const [isLoadingReses, setLoadingReses] = useState(true);
  const [isLoadingKegiatan, setLoadingKegiatan] = useState(true);
  const [dataSidang, setDataSidang] = useState();
  const [dataReses, setDataReses] = useState();
  const [dataKegiatan, setDataKegiatan] = useState();
  const [metaData, setMetaData] = useState({});
  const [totalData, setTotalData] = useState(0);
  const [modal, contextHolder] = Modal.useModal();

  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sort: "created_at",
    total_data: 0,
  });

  const initialState = {
    page: 1,
    limit: 10,
    sort: "created_at",
    total_data: 0,
  };

  const [filtersSidang, setFiltersSidang] = useState(initialState);
  const [filtersReses, setFiltersReses] = useState(initialState);
  const [filtersKegiatan, setFiltersKegiatan] = useState(initialState);

  const tableColumnsSidang = [
    {
      title: "No",
      key: "no",
      render: (_text, _record, index) =>
        (filters.page - 1) * filters.limit + index + 1,
    },
    {
      title: "Judul Sidang",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Jadwal Sidang",
      dataIndex: "date",
      key: "date",
      render: (_, record) => {
        return <div>{moment(record.date).format("YYYY-MM-DD - HH:mm")}</div>;
      },
    },
    {
      title: "Lokasi Sidang",
      dataIndex: "location",
      key: "location",
    },
  ];

  const tableColumnsReses = [
    {
      title: "No",
      key: "no",
      render: (_text, _record, index) =>
        (filters.page - 1) * filters.limit + index + 1,
    },
    {
      title: "Judul Reses",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Jadwal Reses",
      dataIndex: "date",
      key: "date",
      render: (_, record) => {
        return <div>{moment(record.date).format("YYYY-MM-DD - HH:mm")}</div>;
      },
    },
    {
      title: "Lokasi Reses",
      dataIndex: "location",
      key: "location",
    },
  ];

  const tableColumnsKegiatan = [
    {
      title: "No",
      key: "no",
      render: (_text, _record, index) =>
        (filters.page - 1) * filters.limit + index + 1,
    },
    {
      title: "Judul Kegiatan",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Jadwal Kegiatan",
      dataIndex: "date",
      key: "date",
      render: (_, record) => {
        return <div>{moment(record.date).format("YYYY-MM-DD - HH:mm")}</div>;
      },
    },
    {
      title: "Lokasi Kegiatan",
      dataIndex: "location",
      key: "location",
    },
  ];

  const getSidang = async (params) => {
    try {
      setLoadingSidang(true);
      const response = await dispatch(
        fetchAllMeeting({ ...params, type: "sidang" })
      ).unwrap();
      setMetaData(response.meta.page);
      setDataSidang(response.data);
      setLoadingSidang(false);
    } catch (error) {
      setLoadingSidang(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getReses = async (params) => {
    try {
      setLoadingReses(true);
      params.user_id = user?.role === "admin" ? null : user?.id;
      const response = await dispatch(fetchAllReses(params)).unwrap();
      setMetaData(response.meta.page);
      setDataReses(response.data);
      setLoadingReses(false);
    } catch (error) {
      setLoadingReses(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getKegiatan = async (params) => {
    try {
      setLoadingKegiatan(true);
      params.user_id = user?.role === "admin" ? null : user?.id;
      const response = await dispatch(fetchAllActivity(params)).unwrap();
      setMetaData(response.meta.page);
      setDataKegiatan(response.data);
      setLoadingKegiatan(false);
    } catch (error) {
      setLoadingKegiatan(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const handleCategorySelect = (val) => {
    setFilters({ ...filters, category_id: val });
  };

  const handleSubcategorySelect = (val) => {
    setFilters({ ...filters, subcategory_id: val });
  };

  const handleSearchByTitleSidang = (e) => {
    setFiltersSidang({ ...filtersSidang, name: e.target.value });
  };

  const handleSearchByTitleReses = (e) => {
    setFiltersReses({ ...filtersReses, title: e.target.value });
  };

  const handleSearchByTitleKegiatan = (e) => {
    setFiltersKegiatan({ ...filtersKegiatan, title: e.target.value });
  };

  const handleTableChangeSidang = (pagination, filter, sorter) => {
    const sortKey = sorter.order
      ? sorter.order === "ascend"
        ? sorter.field
        : `-${sorter.field}`
      : filtersSidang.sort;

    setFiltersSidang({
      ...filtersSidang,
      page: pagination.current,
      sort: sortKey,
    });
  };

  const handleTableChangeReses = (pagination, filter, sorter) => {
    const sortKey = sorter.order
      ? sorter.order === "ascend"
        ? sorter.field
        : `-${sorter.field}`
      : filtersReses.sort;

    setFiltersReses({
      ...filtersReses,
      page: pagination.current,
      sort: sortKey,
    });
  };

  const handleTableChangeKegiatan = (pagination, filter, sorter) => {
    const sortKey = sorter.order
      ? sorter.order === "ascend"
        ? sorter.field
        : `-${sorter.field}`
      : filtersKegiatan.sort;

    setFiltersKegiatan({
      ...filtersKegiatan,
      page: pagination.current,
      sort: sortKey,
    });
  };

  useEffect(() => {
    console.log("filtersSidang: ", filtersSidang);
    getSidang(filtersSidang);
  }, [filtersSidang]);

  useEffect(() => {
    getReses(filtersReses);
  }, [filtersReses]);

  useEffect(() => {
    getKegiatan(filtersKegiatan);
  }, [filtersKegiatan]);

  return (
    <>
      <LocalizedModal></LocalizedModal>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Jadwal Sidang</h2>
          <p>Tampilkan semua Sidang.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={[16, 2]}>
              <Col xs={24} sm={24} md={12} lg={12} span={6}>
                <Input
                  placeholder="Cari Berdasarkan Nama"
                  onSelect={handleSearchByTitleSidang}
                  className="mb-4 mr-4"
                  allowClear
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Meeting"
                  onSelect={handleCategorySelect}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleCategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Meeting"
                  onSelect={handleSubcategorySelect}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleSubcategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>

            <Table
              className="no-border-last"
              style={{ textAlign: "center", margin: "auto" }}
              scroll={{ x: "100%" }} // Menambahkan scrolling horizontal
              columns={tableColumnsSidang}
              dataSource={dataSidang}
              rowKey="id"
              loading={isLoadingSidang}
              pagination={{
                defaultPageSize: 10,
                defaultCurrent: metaData.page,
                total: metaData.total_data,
              }}
              onChange={handleTableChangeSidang}
            />
          </Card>
        </Col>
      </Row>
      {contextHolder}

      {/* RESES */}

      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Jadwal Reses</h2>
          <p>Tampilkan semua Reses.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={[16, 2]}>
              <Col xs={24} sm={24} md={12} lg={12} span={6}>
                <Input
                  placeholder="Cari Berdasarkan Nama"
                  onSelect={handleSearchByTitleReses}
                  className="mb-4 mr-4"
                  allowClear
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Meeting"
                  onSelect={handleCategorySelect}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleCategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Meeting"
                  onSelect={handleSubcategorySelect}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleSubcategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            {/* <Select
              placeholder="Filter by tags"
              onSelect={handleTagSelect}
              options={tags}
              className="mb-4 mr-4"
              allowClear
              onClear={handleTagSelect}
            /> */}
            <Table
              className="no-border-last"
              style={{ textAlign: "center", margin: "auto" }}
              scroll={{ x: "100%" }} // Menambahkan scrolling horizontal
              columns={tableColumnsReses}
              dataSource={dataReses}
              rowKey="id"
              loading={isLoadingReses}
              pagination={{
                defaultPageSize: 10,
                defaultCurrent: metaData.page,
                total: metaData.total_data,
              }}
              onChange={handleTableChangeReses}
            />
          </Card>
        </Col>
      </Row>
      {/* <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Button
            type="primary"
            style={{ border: "0px" }}
            htmlType="submit"
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_sidang}`,
              });
            }}
            block
          >
            Tambah Sidang
          </Button>
        </Col>
      </Row> */}
      {contextHolder}

      {/* KEGIATAN */}

      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Jadwal Kegiatan</h2>
          <p>Tampilkan semua Kegiatan.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={[16, 2]}>
              <Col xs={24} sm={24} md={12} lg={12} span={6}>
                <Input
                  placeholder="Cari Berdasarkan Nama"
                  onSelect={handleSearchByTitleKegiatan}
                  className="mb-4 mr-4"
                  allowClear
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Meeting"
                  onSelect={handleCategorySelect}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleCategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} span={6}>
                <Select
                  placeholder="Filter Berdasarkan Meeting"
                  onSelect={handleSubcategorySelect}
                  className="mb-4 mr-4"
                  allowClear
                  onClear={handleSubcategorySelect}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            {/* <Select
              placeholder="Filter by tags"
              onSelect={handleTagSelect}
              options={tags}
              className="mb-4 mr-4"
              allowClear
              onClear={handleTagSelect}
            /> */}
            <Table
              className="no-border-last"
              style={{ textAlign: "center", margin: "auto" }}
              scroll={{ x: "100%" }} // Menambahkan scrolling horizontal
              columns={tableColumnsKegiatan}
              dataSource={dataKegiatan}
              rowKey="id"
              loading={isLoadingKegiatan}
              pagination={{
                defaultPageSize: 10,
                defaultCurrent: metaData.page,
                total: metaData.total_data,
              }}
              onChange={handleTableChangeKegiatan}
            />
          </Card>
        </Col>
      </Row>
      {/* <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Button
            type="primary"
            style={{ border: "0px" }}
            htmlType="submit"
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_sidang}`,
              });
            }}
            block
          >
            Tambah Sidang
          </Button>
        </Col>
      </Row> */}
      {contextHolder}
    </>
  );
};

export default withRouter(KEGIATANKU);
